export const answersRowsPerPage = [
  { id: 0, name: 15 },
  { id: 1, name: 25 },
  { id: 2, name: 50 }
];


// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/constants.js